/**
 * Aides de rendu pures (pas de DOM ici, testables sous Node). `app.ts`
 * construit des fragments HTML par gabarits de chaines : toute valeur
 * provenant d'une entree utilisateur (nom, identifiant, URL, notes) DOIT
 * passer par `escapeHtml` avant interpolation, sous peine d'injection dans le
 * coffre local.
 */

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/gu, (char) => HTML_ESCAPES[char] ?? char);
}

/** Domaine lisible d'une URI d'entree, pour l'affichage compact de la liste. */
export function extractDomain(uri: string): string {
  const trimmed = uri.trim();
  if (trimmed.length === 0) return '';
  try {
    const withScheme = /^[a-z][a-z0-9+.-]*:\/\//iu.test(trimmed) ? trimmed : `https://${trimmed}`;
    return new URL(withScheme).hostname.replace(/^www\./u, '');
  } catch {
    return trimmed;
  }
}

/** Initiale(s) utilisees pour l'avatar textuel d'une entree sans icone. */
export function entryInitials(name: string): string {
  const trimmed = name.trim();
  if (trimmed.length === 0) return '?';
  return trimmed.slice(0, 2).toUpperCase();
}

const DATE_FORMATTER = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'short' });

export function formatTimestamp(epochMs: number): string {
  return DATE_FORMATTER.format(new Date(epochMs));
}

/** Masque un mot de passe par des points, en preservant la longueur (indication visuelle sans fuite). */
export function maskSecret(value: string): string {
  return '•'.repeat(Math.min(value.length, 24) || 8);
}
